import React, { Component } from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Grid, Theme, Typography } from "@material-ui/core";
import MyPATStepper from "../../common/MyPATStepper";
import _ from "lodash";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import { connect } from "react-redux";

const styles = (theme: Theme) =>
  createStyles({
    sectionInContentContainer: {
      width: "100%",
      // backgroundColor: "#fff",
      // borderRadius: "4px",
      // boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      // padding: "20px",
    },
    heading: {
      fontWeight: 700,
      fontSize: "17px",
      marginBottom: "20px",
    },
    initialStatusContainer: {
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #e1e1e1",
      borderRadius: "50%",
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 15,
      padding: "3px",
    },
    warningIcon: {
      color: "#FF4A4A !important",
    },
  });

interface Props extends WithStyles<typeof styles> {
  onSectionsValidtyChange?: (
    allSectionsValid: boolean,
    completionPercent: number
  ) => void;
  showDraftPercentage?: boolean;
  currentlyFocusedSection: string;
}

interface State {
  sectionValidity: boolean[];
  completionPercent: number;
}

class SectionInContent extends Component<Props, State> {
  state: State = {
    sectionValidity: React.Children.toArray(this.props.children).map(
      () => false
    ),
    completionPercent: 0,
  };
  onValidation = (childIndex: number, isValid: boolean) => {
    this.setState((prevState) => {
      const newSectionValidity = [...prevState.sectionValidity];
      newSectionValidity[childIndex] = isValid;
      return {
        ...prevState,
        sectionValidity: newSectionValidity,
      };
    });
  };
  countChildren = (children?: React.ReactNode) => {
    return React.Children.toArray(children).map((child) => !!child).length;
  };
  componentDidUpdate(prevProps: any, prevState: State) {
    const currentChildrenCount = this.countChildren(this.props.children);
    const previousChildrenCount = this.countChildren(prevProps.children);
    if (currentChildrenCount !== previousChildrenCount) {
      this.setState({
        sectionValidity: React.Children.toArray(this.props.children).map(
          () => false
        ),
      });
    }

    if (
      this.state.sectionValidity !== prevState.sectionValidity &&
      this.props.onSectionsValidtyChange
    ) {
      const noOfSectionsValid = this.state.sectionValidity.reduce(
        (acc, isValid) => (isValid ? acc + 1 : acc),
        0
      );
      const allSectionsValid = noOfSectionsValid === currentChildrenCount;
      const completion = (noOfSectionsValid / currentChildrenCount) * 100;
      const completionPercent = Math.round(completion * 100) / 100;

      this.setState({
        completionPercent,
      });

      this.props.onSectionsValidtyChange(allSectionsValid, completionPercent);
    }
  }
  initialStatusRenderer = (number: number) => (value: any) => {
    const { classes } = this.props;
    return (
      <ErrorOutline
        className={`${classes.icon} ${classes.warningIcon}`}
        fontSize="large"
      />
    );
  };
  render() {
    const { classes, children, showDraftPercentage, currentlyFocusedSection } = this.props;
    const { completionPercent } = this.state;

    return (
      <Grid
        container
        className={classes.sectionInContentContainer}
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Grid container justify="space-between">
            {/* <Grid item xs="auto">
              <Typography variant="h6" className={classes.heading}>
                Sections in This Content
              </Typography>
            </Grid> */}
            {/* {showDraftPercentage && (
              <Grid item xs="auto">
                <Typography variant="body1">
                  {completionPercent}% completed
                </Typography>
              </Grid>
            )} */}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MyPATStepper
            disabledDivider
            // dividerHeight="26px"
            // dividerLeftShift="12px"
            dividerBorder="none"
          >
            {React.Children.map(children, (child, i) => {
              if (!child) {
                return null;
              }
              // @ts-ignore
              const sectionId = child.props.sectionId || '';

              const isCurrentlyEditing = _.camelCase(sectionId) === currentlyFocusedSection;

              // @ts-ignore
              return React.cloneElement(child, {
                initialStatusRenderer: this.initialStatusRenderer(i + 1),
                onValidation: (isValid: boolean) =>
                  this.onValidation(i, isValid),
                isCurrentlyEditing,
              });
            })}
          </MyPATStepper>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentlyFocusedSection: state.commonData.focusedSection.currentlyFocusedSection,
  }
}

// @ts-ignore
export default withStyles(styles)(connect(mapStateToProps)(SectionInContent));
